import { OktaAuth, OktaAuthOptions } from "@okta/okta-auth-js";
import { AppRoutes } from "./shared/common/app-path.routes";
import { BASE_URL, environment } from "./environments/environment.development";

export const oktaAuthConfig: OktaAuthOptions = {
  // issuer: 'https://cbsi.okta.com/oauth2/default',
  // clientId: '{yourClientId}',
  // redirectUri: `${window.location.origin}/login/callback`,
  // clientId: '0oa1tbbwgokGt3a1S1d8',
  clientId: environment.oktaClientId,
  issuer: "https://cbsi.okta.com",
  authorizeUrl: "https://cbsi.okta.com/oauth2/v1/authorize",
  // redirectUri: 'http://cpam-dev.paramount.com/callback',
   redirectUri: `${BASE_URL}${AppRoutes.LoginCallback}`,
  //redirectUri: `http://localhost:4200/${AppRoutes.LoginCallback}`,
  // redirectUri: `${BASE_URL}${AppRoutes.LoginCallback}`,
  pkce: true,
  responseType: "code",
  scopes: ["openid", "profile", "email"],
  tokenManager: { storage: "localStorage" },
  // tokenManager: { storage: "localStorage", autoRenew: false },
};
export const oktaAuth = new OktaAuth(oktaAuthConfig);
